'use strict'

const { createCmd } = require('redux-serial-effects')

const TYPE = 'ADAPTER_API'

const BIND_TO_COMPONENT = 'BIND_TO_COMPONENT'
const CURRENT_RECORD_MODIFIED = 'CURRENT_RECORD_MODIFIED'
const RECORD_SET_LOADED = 'RECORD_SET_LOADED'
const CURRENT_VIEW_CHANGED = 'CURRENT_VIEW_CHANGED'
const CURRENT_INDEX_CHANGED = 'CURRENT_INDEX_CHANGED'

const provider = adapterApi => ({
  type: TYPE,
  runner: cmd => {
    switch (cmd.eventType) {
      case BIND_TO_COMPONENT:
        return adapterApi().bindToComponent()

      case CURRENT_RECORD_MODIFIED:
        return adapterApi().currentRecordModified(
          cmd.updatedFields,
          cmd.filteredComponent
        )

      case RECORD_SET_LOADED:
        return Promise.all(adapterApi().recordSetLoaded())

      case CURRENT_VIEW_CHANGED:
        return Promise.all(adapterApi().currentViewChanged())

      case CURRENT_INDEX_CHANGED:
        return adapterApi().currentIndexChanged()
    }
  }
})

const bindToComponentCmd = () =>
  createCmd(TYPE, false, {
    eventType: BIND_TO_COMPONENT
  })

const currentRecordModifiedCmd = (updatedFields, filteredComponent) =>
  createCmd(TYPE, false, {
    eventType: CURRENT_RECORD_MODIFIED,
    updatedFields,
    filteredComponent
  })

const recordSetLoadedCmd = () =>
  createCmd(TYPE, true, {
    eventType: RECORD_SET_LOADED
  })

const currentViewChangedCmd = () =>
  createCmd(TYPE, true, {
    eventType: CURRENT_VIEW_CHANGED
  })

const currentIndexChangedCmd = () =>
  createCmd(TYPE, false, {
    eventType: CURRENT_INDEX_CHANGED
  })

module.exports.provider = provider
module.exports.bindToComponentCmd = bindToComponentCmd
module.exports.currentRecordModifiedCmd = currentRecordModifiedCmd
module.exports.recordSetLoadedCmd = recordSetLoadedCmd
module.exports.currentIndexChangedCmd = currentIndexChangedCmd
module.exports.currentViewChangedCmd = currentViewChangedCmd



// WEBPACK FOOTER //
// ./adapters/adapterApiProvider.js